import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { Text } from '@/components/ui/Typography/Body/Text';
import { ArticleHead } from '@/components/ui/Typography/Heading/ArticleHead';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { transformHtml, reactHtmlParser, } from '@/utils/libs/react-html-parser/parse';
/** className の変換設定 */
const settings = [
    {
        className: clsx('text-link', 'hover:underline', 'cursor-pointer'),
        tagName: 'a',
    },
    {
        className: clsx('font-bold'),
        tagName: 'b',
    },
    {
        className: clsx('max-w-full'),
        tagName: 'img',
    },
    {
        className: clsx('flex flex-col gap-y-8', 'pl-20'),
        tagName: 'ol',
    },
    {
        className: clsx('flex flex-col gap-y-8', 'list-disc', 'pl-20'),
        tagName: 'ul',
    },
    {
        component: (index, children) => (_jsx(Head, Object.assign({ className: clsx('md:text-head-xxxl', 'mb-40', index !== 0 && 'mt-60'), color: 'base', size: 'xl' }, { children: children }), index)),
        tagName: 'h1',
    },
    {
        component: (index, children) => (_jsx(ArticleHead, Object.assign({ className: clsx('mb-40', index !== 0 && 'mt-60') }, { children: children }), index)),
        tagName: 'h2',
    },
];
/**
 * HTML文字列をHTMLに変換するコンポーネント
 * @description コラムや事例詳細等で使用。適切なスタイルが付与されたHTMLに変換する
 */
export const ArticleHtmlTransformText = (props) => {
    const { children, className } = props;
    const content = useMemo(() => reactHtmlParser(children, {
        transform: transformHtml(settings),
    }), [children]);
    return (_jsx(Text, Object.assign({ className: clsx('break-all', className), color: 'base', size: 'md' }, { children: content })));
};
